module.exports = __webpack_public_path__ + "static/model-off-image-3-037273ce1e1b801833e9c3835508e38b.jpg";